<script setup lang="ts">
import ExerciseMCQ from "~/features/computer/components/ExerciseMCQ.vue";
import { commentsContent } from "~/features/python/ch2/comments/data/comments.content";
</script>

<template>
  <section class="space-y-4 rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
    <div>
      <h2 class="text-lg font-semibold text-slate-900">Chhota test</h2>
      <p class="mt-1 text-sm text-slate-600">Ab check karo ke comment aur code ka farq samajh aaya ya nahi.</p>
    </div>

    <ExerciseMCQ
      v-for="question in commentsContent.quiz"
      :key="question.id"
      :question="question"
    />
  </section>
</template>
